<div class="app-content">
  <div class="content-wrap" layout-full-width layout-full-height>
    <rtc-detached-router-outlet />
  </div>
</div>
